// extracted by mini-css-extract-plugin
export default {"badge":"status-pill_badge__CC9by","badgeDot":"status-pill_badgeDot__AojCo"};